<template>
    <div>
        <h2 class="text-md-center">Technical Skills</h2>
        <Skill :skills="generalscience.skills" :skill-area="'General Science'"></Skill>
        <Skill :skills="microbiology.skills" :skill-area="'Microbiology'"></Skill>
        <Skill :skills="genetics.skills" :skill-area="'Genetics'"></Skill>
        <Skill :skills="computer.skills" :skill-area="'Computer Science'"></Skill>
    </div>
</template>

<script>
    import Skill from "@/components/Skill";

    export default {
        name: "SkillAreas",
        components: {
            Skill
        },
        data() {
            return {
                computer: {
                    skills: [
                        {
                            name: 'R',
                            expertise: 'Beginner',
                            imgFlag: true
                        },
                        {
                            name: 'Python',
                            expertise: 'Intermediate',
                            imgFlag: true
                        },
                        {
                            name: 'C++',
                            expertise: 'Intermediate',
                            imgFlag: true
                        },
                        {
                            name: 'Vue.js',
                            expertise: 'Pursuing',
                            imgFlag: true
                        },
                        {
                            name: 'Data Mining and Machine Learning',
                            expertise: 'Beginner',
                            imgFlag: false
                        },
                        {
                            name: 'Data Visualization',
                            expertise: 'Beginner',
                            imgFlag: false
                        },
                        {
                            name: 'PostgreSQL',
                            expertise: 'Beginner',
                            imgFlag: true
                        },
                        {
                            name: 'JS',
                            expertise: 'Beginner',
                            imgFlag: true
                        },
                        {
                            name: 'HTML 5',
                            expertise: 'Apprentice',
                            imgFlag: true
                        }
                    ]
                },
                microbiology: {
                    skills: [
                        {
                            name: 'Micropippet',
                            expertise: 'Advanced',
                            imgFlag: false
                        },
                        {
                            name: 'Spectrophotometer',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: 'Microscope',
                            expertise: 'Advanced',
                            imgFlag: false
                        },
                        {
                            name: 'Electron Microscopy',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: 'Fermentation',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: 'Bacterial Culturing and Maintenance',
                            expertise: 'Advanced',
                            imgFlag: false
                        },
                        {
                            name: '6X6 Bacterial Testing',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: '96 Well Plate Testing',
                            expertise: 'Beginner',
                            imgFlag: false
                        },
                        {
                            name: 'Metabolic Testing',
                            expertise: 'Beginner',
                            imgFlag: false
                        },
                        {
                            name: 'Serial Dilutions',
                            expertise: 'Advanced',
                            imgFlag: false
                        },
                        {
                            name: 'Bacterial Transformation',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: 'Bacterial Identification',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: 'VIDAS Testing',
                            expertise: 'Beginner',
                            imgFlag: false
                        },
                        {
                            name: 'BAX PCR Testing',
                            expertise: 'Beginner',
                            imgFlag: false
                        },
                        {
                            name: 'Viral Maintenance and Upkeep',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: 'Phage Isolation and Maintenance',
                            expertise: 'Beginner',
                            imgFlag: false
                        },
                        {
                            name: 'Petrifilm',
                            expertise: 'Intermediate',
                            imgFlag: false
                        }
                    ]
                },
                generalscience: {
                    skills: [
                        {
                            name: 'Micropippet',
                            expertise: 'Advanced',
                            imgFlag: false
                        },
                        {
                            name: 'Spectrophotometer',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: 'Eukaryotic and Prokaryotic Cell Culturing and Maintenance',
                            expertise: 'Advanced',
                            imgFlag: false
                        },
                        {
                            name: 'Microscopes',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: 'pH Meter',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: 'Scientific Scales',
                            expertise: 'Advanced',
                            imgFlag: false
                        },
                        {
                            name: 'Morphology',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: 'Lab Note Taking',
                            expertise: 'Advanced',
                            imgFlag: false
                        },
                        {
                            name: 'Serial Dilutions',
                            expertise: 'Advanced',
                            imgFlag: false
                        }
                    ]
                },
                genetics: {
                    skills: [
                        {
                            name: 'PCR',
                            expertise: 'Advanced',
                            imgFlag: false
                        },
                        {
                            name: 'Electrophoresis',
                            expertise: 'Advanced',
                            imgFlag: false
                        },
                        {
                            name: 'qPCR',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: 'DNA Sequencing',
                            expertise: 'Apprentice',
                            imgFlag: false
                        },
                        {
                            name: 'Recombinant DNA Techniques',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: 'Bacterial Transformation',
                            expertise: 'Intermediate',
                            imgFlag: false
                        },
                        {
                            name: 'DNA Sequence Analysis',
                            expertise: 'Beginner',
                            imgFlag: false
                        },
                        {
                            name: 'Oligo primer creation',
                            expertise: 'Pursuing',
                            imgFlag: false
                        }
                    ]


                }
            }
        }
    }
</script>

<style scoped>

</style>
